import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSync = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 15.9999L4 15.9999M4 15.9999L7 12.9999M4 15.9999L7.00006 19M5 7.99994L20 7.99994M20 7.99994L17.0001 5M20 7.99994L17.0001 10.9999",
		stroke: "#000000",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgSync as ReactComponent };
